(() => {
  let hideSoldOut = false;

  function updateCards() {
    document.querySelectorAll('.cf-card').forEach(card => {
      const isAvailable = card.dataset.available === 'true';

      card.style.display =
        hideSoldOut && !isAvailable ? 'none' : '';
    });

    document
      .querySelectorAll('.availability-filter-button')
      .forEach(button => {
        button.textContent =
          hideSoldOut ? 'Show All' : 'Show Only Shippable';
      });
  }

  document.addEventListener('click', event => {
    const button = event.target.closest('.availability-filter-button');
    if (!button) return;

    event.preventDefault();

    hideSoldOut = !hideSoldOut;
    updateCards();
  });
})();